import { render, staticRenderFns } from "./AS_TanUpdate.vue?vue&type=template&id=2011566f&scoped=true&"
import script from "./AS_TanUpdate.vue?vue&type=script&lang=js&"
export * from "./AS_TanUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AS_TanUpdate.vue?vue&type=style&index=0&id=2011566f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2011566f",
  null
  
)

export default component.exports